import { getTranslation } from '@easy-expense/intl-client';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';

import { RowCard } from './RowCard.component';
import { Button } from '../../Button.components';

export const ManageSubscription: React.FC<{
  activeMembers: number;
  // Omitted for an individual (Starter/Professional) subscriber — those plans have a fixed
  // seat cap, not a self-serve add-seats purchase; the row hides instead of no-op'ing.
  onAddSeats?: () => void;
  onChangePlan?: () => void;
  onCancel?: () => void;
  cancelDisabled?: boolean;
  // Provided only while the subscription is scheduled to cancel; reactivates it
  // in place. When present, it replaces the cancel row (which is hidden while
  // lapsing) so the admin always has an action.
  onResume?: () => void;
}> = ({ activeMembers, onAddSeats, onChangePlan, onCancel, cancelDisabled, onResume }) => {
  let subtitle = getTranslation('Switch plans or cancel your subscription.');
  if (onAddSeats) {
    subtitle = getTranslation('Add more seats, switch plans, or cancel your subscription.');
  }

  return (
    <Layout.Column>
      <OpenSans.Primary weight="bold-700" size="m-18" color="primary">
        {getTranslation('Manage subscription')}
      </OpenSans.Primary>
      <Spacer.Vertical size={4} />
      <OpenSans.Primary size="xs-12" color="secondary">
        {subtitle}
      </OpenSans.Primary>
      <Spacer.Vertical size={16} />

      {onAddSeats ? (
        <>
          <RowCard
            iconName="people-outline"
            title={getTranslation('Add seats')}
            description={`${getTranslation('Cover your full team of')} ${activeMembers}. ${getTranslation(
              'Prorated charges apply immediately.',
            )}`}
            action={<Button.Primary content={getTranslation('Add seats')} onClick={onAddSeats} />}
          />
          <Spacer.Vertical size={12} />
        </>
      ) : null}

      {onChangePlan ? (
        <>
          <RowCard
            iconName="arrow-redo-outline"
            title={getTranslation('Change plan')}
            description={getTranslation('Compare plans, or move to annual billing for a discount.')}
            action={
              <Button.Secondary content={getTranslation('Change plan')} onClick={onChangePlan} />
            }
          />
          <Spacer.Vertical size={12} />
        </>
      ) : null}

      {onResume ? (
        <RowCard
          iconName="refresh-outline"
          title={getTranslation('Resume subscription')}
          description={getTranslation(
            'Your subscription is scheduled to cancel. Resume it to keep your plan, price, and billing date.',
          )}
          action={
            <Button.Primary content={getTranslation('Resume subscription')} onClick={onResume} />
          }
        />
      ) : null}

      {onCancel ? (
        <RowCard
          variant="danger"
          iconName="close-circle-outline"
          title={getTranslation('Cancel subscription')}
          description={getTranslation(
            'End your subscription. Your team retains read-only access until the end of the billing period.',
          )}
          action={
            <Button.Destructive
              content={getTranslation('Cancel Subscription')}
              onClick={onCancel}
              active={!cancelDisabled}
            />
          }
        />
      ) : null}
    </Layout.Column>
  );
};
